import React from 'react'
import {Modal} from 'react-bootstrap'

function BackModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title 
          id="contained-modal-title-vcenter" className="text-center"
          >
            Document Image Back
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          
        <img style={img_doc} src={props.img4} alt="document" />
        </Modal.Body>
        <Modal.Footer>
         
        </Modal.Footer>
      </Modal>
    );
  }
  export default BackModal;

  const img_doc = {
    width: '100%',
    height: "30rem"
}